import React, { memo } from 'react';

import { colors } from 'constants-colors';

import styles from './MaintenancePage.scss';

function MaintenancePage() {
  return (
    <div className={styles.container}>
      <svg
        className={styles.toolsIllustration}
        width="282"
        height="222"
        viewBox="0 0 282 222"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          d="M119.357 219.395C64.1058 213.428 19.4028 202.272 4.01109 175.434C-20.2882 133.064 77.3118 98.8471 157.53 101.753C193.503 103.056 240.355 106.04 253.329 116.507C266.302 126.973 207.226 126.777 218.242 142.727C245.982 182.894 293.327 181.35 278.645 194.734C263.963 208.117 174.608 225.363 119.357 219.395Z"
          fill={colors.laneMint}
        />
        <path
          d="M217.484 140.609L173.891 96.6641C168.266 91.3906 161.234 88.5781 153.852 88.5781C148.578 88.5781 142.953 89.9844 138.383 93.1484L108.5 63.2656V37.25L63.5 3.5L41 26L74.75 71H100.414L130.297 101.234C123.266 112.133 124.32 126.898 134.164 136.742L177.758 180.336C179.867 182.445 183.031 183.852 185.844 183.852C188.656 183.852 191.469 182.445 193.578 180.336L217.484 156.43C222.055 152.211 222.055 144.828 217.484 140.609ZM97.25 59.3984V59.75H80.375L55.7656 27.0547L64.5547 18.6172L97.25 42.875V59.3984ZM185.844 172.25L141.898 128.656C138.734 125.492 136.977 121.273 136.977 116.703C136.977 112.133 138.734 107.914 141.898 104.75C145.062 101.586 149.281 99.8281 153.852 99.8281C158.422 99.8281 162.641 101.586 165.805 104.75L209.75 148.695L185.844 172.25ZM63.5 155.375C63.5 158.539 65.9609 161 69.125 161C71.9375 161 74.75 158.539 74.75 155.375C74.75 152.562 71.9375 149.75 69.125 149.75C65.9609 149.75 63.5 152.562 63.5 155.375ZM138.031 27.0547C146.117 19.3203 156.664 14.75 167.562 14.75C170.023 14.75 172.484 15.1016 174.945 15.4531L150.688 40.0625L155.258 69.2422L184.438 73.8125L209.047 49.5547C211.156 62.9141 206.938 76.625 197.445 86.4688C194.281 89.6328 190.766 92.0938 186.898 93.8516L194.984 102.289C198.852 100.18 202.016 97.3672 205.18 94.2031C218.539 80.8438 223.812 62.2109 219.242 43.9297C218.539 40.4141 215.727 37.9531 212.562 36.8984C209.047 36.1953 205.531 36.8984 203.07 39.3594L180.57 61.8594L165.102 59.3984L162.641 43.9297L185.141 21.4297C187.25 18.9688 188.305 15.4531 187.602 11.9375C186.547 8.77344 183.734 5.96094 180.57 5.25781C162.289 0.6875 143.656 5.96094 130.297 19.3203C125.727 23.8906 122.211 29.1641 119.75 34.7891V58.6953L127.484 66.4297C123.969 52.0156 127.836 37.25 138.031 27.0547ZM78.6172 168.031C72.6406 173.656 62.4453 173.656 56.4688 168.031C50.4922 161.703 50.4922 151.859 56.4688 145.883L107.797 94.5547L100.062 86.8203L48.7344 138.148C38.1875 148.344 38.1875 165.57 48.7344 175.766C53.6562 181.039 60.3359 183.5 67.3672 183.5C74.75 183.5 81.4297 181.039 86.3516 175.766L122.211 139.906C119.75 136.742 117.992 133.227 116.586 129.711L78.6172 168.031Z"
          fill="url(#paint0_linear_14_41)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_14_41"
            x1="41"
            y1="3"
            x2="252.588"
            y2="55.3668"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor={colors.laneGreen} />
            <stop offset="1" stopColor={colors.interactiveBlue} />
          </linearGradient>
        </defs>
      </svg>

      <h1 className={styles.header}>This site is under maintenance</h1>
      <p className={styles.text}>
        We’re undergoing maintenance and will be back soon.
      </p>
      <p className={styles.text}>Please check our status page for updates.</p>
      <a
        className={styles.statusButton}
        href="https://status.vts.com"
        target="_blank"
        rel="noreferrer"
      >
        Check Status
      </a>
    </div>
  );
}

export default memo(MaintenancePage);
